import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  TextField, Button, Box, Typography, IconButton, Grid, List, ListItem,
  ListItemText, ListItemSecondaryAction, MenuItem, FormControlLabel, Checkbox, CircularProgress,
  Grid2,
  Divider
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { ApiRequest } from '../../services/api';

import { Alert } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const EditRecipe = () => {
  const { id } = useParams();
  const [recipe, setRecipe] = useState({
    nombre: '',
    descripcion: '',
    tiempoPreparacion: '',
    tiempoCoccion: '',
    porciones: '',
    estatus: '',
    estatus: '',
    tipoCocinero: '',
    clasificacionReceta: '',
    gastronomia: '',
    fitFat: '',
    temporada: '',
    alergeno: '',
    tiemposDia: [],
    categoria: '',
    momentoDelDia: '',
    urlCompra: '',
    imagen: '',
    notaIdr: '',
    ingredientes: [],
    procedimientos: [],
    informacionNutrimental: [],
    etiquetasInformacionNutricional: [],
    urlVideo: '',
    categoriaAlimenticia: '',
    metaTitle: '',
    metaDescription: '',
    keyWords: '',
    altText: '',
    altImage: ''
  });

  const [newIngredient, setNewIngredient] = useState({ ingredienteId: '', cantidad: '', instrucciones: '' });
  const [availableIngredients, setAvailableIngredients] = useState([]);
  const [newCategoria, setNewCategoria] = useState({ categoriaId: '' });
  const [availableCategoria, setAvailableCategoria] = useState([]);
  const [newTiempoDia, setNewTiempoDia] = useState({ tiempoDiaId: '' });
  const [availableTiempoDia, setAvailableTiempoDia] = useState([]);
  const [availableMomentoDia, setAvailableMomentoDia] = useState([]);
  const [newMomentoDia, setNewMomentoDia] = useState({ momentoDiaId: '' });
  const [newClasificacionReceta, setNewClasificacionReceta] = useState({ clasificacionRecetaId: '' });
  const [availableClasificacionReceta, setAvailableClasificacionReceta] = useState([]);
  const [availableGastronomias, setAvailableGastronomias] = useState([]);
  const [availableFitFat, setAvailableFitFat] = useState([]);
  const [availableTemporada, setAvailableTemporada] = useState([]);
  const [availableAlergeno, setAvailableAlergeno] = useState([]);
  const [newPaso, setNewPaso] = useState({
    descripcion: '',
    esTip: false
  });
  const [newInfoNutricional, setNewInfoNutricional] = useState({ id: '', nutriente: '', totalReceta: '', porPorcion: '', idr: '' });
  const [availableEtiquetasInformacionNutricional, setAvailableEtiquetasInformacionNutricional] = useState([]);
  const [newEtiquetaInformacionNutricional, setNewEtiquetaInformacionNutricional] = useState({ etiquetaId: '' });
  const [imagePreview, setImagePreview] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [uploadError, setUploadError] = useState('');
  const [videoFile, setVideoFile] = useState(null);
  const [videoPreview, setVideoPreview] = useState('');
  const [videoUrl, setVideoUrl] = useState('');
  const [uploadProgress, setUploadProgress] = useState(0);
  const [videoUploaded, setVideoUploaded] = useState(false);
  const [videoDeleted, setVideoDeleted] = useState(false);


  useEffect(() => {
    const fetchRecipe = async () => {
      setLoading(true);
      setVideoUploaded(false);
      try {
        const response = await ApiRequest(`api/Recetas/RecetaId/${id}`, 'GET');
        setRecipe(prev => ({
          ...prev,
          nombre: response.nombre,
          descripcion: response.descripcion,
          tiempoPreparacion: response.tiempoPreparacion,
          tiempoCoccion: response.tiempoCoccion,
          porciones: response.porciones,
          estatus: response.estatus,
          tipoCocinero: response.tipoCocinero,
          clasificacionReceta: response.clasificacionId,
          gastronomia: response.gastronomiaId,
          fitFat: response.masFitMenosFatId,
          temporada: response.temporadaId,
          alergeno: response.alergenoId,
          urlCompra: response.urlCompra,
          notaIdr: response.notaIdr,
          ingredientes: response.ingredientes,
          procedimientos: response.procedimientos,
          informacionNutrimental: response.informacionNutrimental,
          etiquetasInformacionNutricional: response.etiquetaInformacionNutrimental,
          categoriaAlimenticia: response.categoriaAlimenticia,
          tiemposDia: response.tiemposDia,
          momentoDelDia: response.momentoDelDia,
          imagen: response.imagen,
          urlImagen: response.urlImagen,
          urlVideo: response.urlVideo,
          metaTitle: response.seoData[0]?.metaTitle || '',
          metaDescription: response.seoData[0]?.metaDescription || '',
          keyWords: response.seoData[0]?.keyWords || '',
          altText: response.seoData[0]?.altText || '',
          altImage: response.seoData[0]?.altImage || ''
        }));

        console.log('Recipe fetched:', response);

        setNewClasificacionReceta({ clasificacionRecetaId: response.clasificacionReceta });
        setNewCategoria({ categoriaId: response.categoriaAlimenticia?.id ?? '' });
        setNewMomentoDia({ momentoDiaId: response.momentoDelDia?.id ?? '' });
        setNewClasificacionReceta({ clasificacionRecetaId: response.clasificacionReceta ?? '' });
        setVideoUrl(response.urlVideo);
        setImagePreview(`data:image/jpeg;base64,${response.imagen}`);
      } catch (error) {
        console.error('Error fetching recipe:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchRecipe();
  }, [id]);

  const handleVideoUpload = async () => {
    if (!videoFile) {
      setUploadError('Selecciona un archivo de video');
      return;
    }

    try {
      // Sanitizar nombre de archivo
      const sanitizedName = videoFile.name
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_.]/g, '');

      // Paso 1: Obtener Signed URL del backend

      const response = await ApiRequest('api/Media/firmar', 'POST', {
        nombreArchivo: sanitizedName,
        contentType: videoFile.type
      });

      if (!response || !response.url) {
        throw new Error('No se pudo obtener URL firmada');
      }

      const signedUrl = response.url;

      // Paso 2: Subir el archivo usando la signed URL
      const uploadResponse = await fetch(signedUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': videoFile.type
        },
        body: videoFile
      });

      if (!uploadResponse.ok) throw new Error('Error al subir el video');

      // const bucketName = process.env.GCP_BUCKET_NAME;
      // const basePath = process.env.GCP_BASE_PATH;
      const bucketName = window.GCP_BUCKET_NAME || "ghdz-bucket-hoy-toca-qa";
      const basePath = window.GCP_BASE_PATH || "hoytoca2025";

      // Establecer la URL final del archivo
      const publicUrl = `https://storage.googleapis.com/${bucketName}/${basePath}/videos_recetas/${sanitizedName}`;
      setVideoUrl(publicUrl);
      setUploadError('');
      setVideoUploaded(true);
      setVideoDeleted(false);

    } catch (error) {
      console.error(error);
      setUploadError(error.message || 'Error al subir video');
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await fetchCategoria();
      await fetchIngredients();
      await fetchTiempoDia();
      await fetchMomentoDia();
      await fetchClasificacionReceta();
      await fetchGastronomias();
      await fetchFitFat();
      await fetchTemporada();
      await fetchAlergeno();
      setLoading(false);
    }
    const fetchCategoria = async () => {
      try {
        const response = await ApiRequest('api/Catalogo/ListarCategoriasAlimenticias', 'GET');
        setAvailableCategoria(response);
      } catch (error) {
        console.error('Error fetching Categorias:', error);
      }
    };

    const fetchIngredients = async () => {
      try {
        const response = await ApiRequest('api/Ingrediente/ListarIngredientes', 'GET');
        const sortedIngredients = [...response].sort((a, b) =>
          a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' })
        );
        setAvailableIngredients(sortedIngredients);
      } catch (error) {
        console.error('Error fetching ingredients:', error);
      }
    };

    const fetchTiempoDia = async () => {
      try {
        const response = await ApiRequest('api/TiemposDia/ListarTiemposDia', 'GET');
        setAvailableTiempoDia(response);
      } catch (error) {
        console.error('Error fetching tiempo dia:', error);
      }
    };

    const fetchMomentoDia = async () => {
      try {
        const response = await ApiRequest('api/Catalogo/ListarMomentosDia', 'GET');
        setAvailableMomentoDia(response);
      } catch (error) {
        console.error('Error fetching momento dia:', error);
      }
    };

    const fetchClasificacionReceta = async () => {
      try {
        const response = await ApiRequest('api/Catalogo/ListarClasificacionesDeReceta', 'GET');
        setAvailableClasificacionReceta(response);
      } catch (error) {
        console.error('Error fetching clasificacion receta:', error);
      }
    }

    const fetchGastronomias = async () => {
      try {
        const response = await ApiRequest('api/Catalogo/ListarGastronomias', 'GET');
        setAvailableGastronomias(response);
      } catch (error) {
        console.error('Error fetching clasificacion receta:', error);
      }
    }

    const fetchFitFat = async () => {
      try {
        const response = await ApiRequest('api/Catalogo/ListarMasFit', 'GET');
        setAvailableFitFat(response);
      } catch (error) {
        console.error('Error fetching clasificacion receta:', error);
      }
    }

    const fetchTemporada = async () => {
      try {
        const response = await ApiRequest('api/Catalogo/ListarTemporadas', 'GET');
        setAvailableTemporada(response);
      } catch (error) {
        console.error('Error fetching clasificacion receta:', error);
      }
    }

    const fetchAlergeno = async () => {
      try {
        const response = await ApiRequest('api/Catalogo/ListarAlergenos', 'GET');
        setAvailableAlergeno(response);
      } catch (error) {
        console.error('Error fetching clasificacion receta:', error);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    const fetcEtiquetaInfoNutricional = async () => {
      try {
        const response = await ApiRequest('api/Catalogo/ListarEtiquetasInformacionNutricional', 'GET');
        const sortedEtiquetas = [...response].sort((a, b) =>
          a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' })
        );
        setAvailableEtiquetasInformacionNutricional(sortedEtiquetas);
      } catch (error) {
        console.error('Error fetching Etiquetas:', error);
      }
    };

    fetcEtiquetaInfoNutricional();
  }, []);

  useEffect(() => {
    if (recipe.urlImagen) {
      fetchImageAsBase64(recipe.urlImagen);
    }
  }, [recipe.urlImagen]);

  const fetchImageAsBase64 = async (imageUrl) => {
    try {
      console.log('fetch image');
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1];
        setRecipe({ ...recipe, imagen: base64String });
        setImagePreview(reader.result);
      };

      reader.readAsDataURL(blob);
    } catch (error) {
      console.error('Error fetching image:', error);
    }
  };

  const handleSave = async () => {
    const recetaData = {
      RecetaId: id,
      Nombre: recipe.nombre,
      Descripcion: recipe.descripcion,
      TiempoPreparacion: parseInt(recipe.tiempoPreparacion),
      TiempoCoccion: parseInt(recipe.tiempoCoccion ?? "0"),
      Porciones: parseInt(recipe.porciones),
      Estatus: recipe.estatus,
      TipoDeConcinero: recipe.tipoCocinero,
      TiemposDia: (recipe.tiemposDia ?? []).map(i => i.id),
      CategoriaAlimenticia: recipe.categoriaAlimenticia.id,
      MomentoDia: newMomentoDia.momentoDiaId ?? null,
      ClasificacionReceta: recipe.clasificacionReceta,
      Gastronomia: recipe.gastronomia,
      FitFat: recipe.fitFat,
      Temporada: recipe.temporada,
      Alergeno: recipe.alergeno,
      UrlCompra: recipe.urlCompra,
      ImagenBase64: recipe.imagen,
      VideoUrl: videoUrl,
      NotaIdr: recipe.notaIdr,
      Ingredientes: (recipe.ingredientes ?? []).map(i => ({
        IngredienteId: i.id,
        Cantidad: i.cantidad,
        Instrucciones: i.instrucciones
      })),
      ListaDePasos: (recipe.procedimientos ?? []).map(i => ({
        NoPaso: i.noPaso,
        Descripcion: i.descripcion,
        EsTip: i.esTip
      })),
      InformacionNutricional: (recipe.informacionNutrimental ?? []).map(i => ({
        Nutriente: i.nutriente,
        TotalReceta: i.totalReceta,
        PorPorcion: i.porPorcion,
        Idr: i.idr
      })),
      EtiquetasInformacionNutricional: (
        recipe.etiquetasInformacionNutricional || []
      ).map(item => item.id ?? item.etiquetaId),
      MetaTitle: recipe.metaTitle,
      MetaDescription: recipe.metaDescription,
      KeyWords: recipe.keyWords,
      AltText: recipe.altText,
      AltImage: recipe.altImage
    };

    try {
      setLoading(true);
      await ApiRequest(`api/Recetas/Modificar`, 'POST', recetaData);
      navigate('/Dashboard/Recetas');
    } catch (error) {
      console.error('Error updating receta:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddIngredient = () => {
    if (newIngredient.ingredienteId && newIngredient.cantidad) {
      const selectedIngredient = availableIngredients.find(i => i.id === newIngredient.ingredienteId);

      if (!selectedIngredient) return;

      const ingredienteCompleto = {
        id: selectedIngredient.id,
        nombre: selectedIngredient.nombre,
        cantidad: newIngredient.cantidad,
        instrucciones: newIngredient.instrucciones
      };

      setRecipe({
        ...recipe,
        ingredientes: [...(recipe.ingredientes ?? []), ingredienteCompleto]
      });

      setNewIngredient({ ingredienteId: '', cantidad: '', instrucciones: '' });
    }
  };


  const handleAddTiempoDia = () => {
    if (newTiempoDia.tiempoDiaId) {
      const selectedTiempo = availableTiempoDia.find(td => td.id === newTiempoDia.tiempoDiaId);

      if (!selectedTiempo) return;

      const yaExiste = (recipe.tiemposDia ?? []).some(td => td.id === selectedTiempo.id);
      if (yaExiste) return;

      setRecipe((prevRecipe) => ({
        ...prevRecipe,
        tiemposDia: [...(prevRecipe.tiemposDia ?? []), selectedTiempo]
      }));

      setNewTiempoDia({ tiempoDiaId: '' });
    }
  };



  const handleAddEtiqueta = () => {
    if (newEtiquetaInformacionNutricional.etiquetaId) {
      const selectedEtiqueta = availableEtiquetasInformacionNutricional.find(
        (e) => e.id === newEtiquetaInformacionNutricional.etiquetaId
      );

      if (!selectedEtiqueta) return;

      const nuevaEtiqueta = {
        etiquetaId: selectedEtiqueta.id,
        nombre: selectedEtiqueta.nombre
      };

      setRecipe((prevRecipe) => ({
        ...prevRecipe,
        etiquetasInformacionNutricional: [
          ...(prevRecipe.etiquetasInformacionNutricional ?? []),
          nuevaEtiqueta
        ]
      }));

      setNewEtiquetaInformacionNutricional({ etiquetaId: '' });
    }
  };


  const handleAddPaso = () => {
    if (!newPaso.descripcion.trim()) return;

    setRecipe(prev => {
      // Calculamos el siguiente número de paso
      const siguienteNo = (prev.procedimientos?.length ?? 0) + 1;
      const paso = {
        noPaso: siguienteNo,
        descripcion: newPaso.descripcion.trim(),
        esTip: newPaso.esTip
      };

      return {
        ...prev,
        procedimientos: [...(prev.procedimientos ?? []), paso]
      };
    });

    // Reseteamos el form
    setNewPaso({
      descripcion: '',
      esTip: false
    });
  };

  const handleAddInfoNutricional = () => {
    if (newInfoNutricional.nutriente && newInfoNutricional.totalReceta && newInfoNutricional.porPorcion && newInfoNutricional.idr) {
      setRecipe((prevRecipe) => ({
        ...prevRecipe,
        informacionNutrimental: [...(prevRecipe.informacionNutrimental ?? []), { ...newInfoNutricional }]
      }));
      setNewInfoNutricional({ id: '', nutriente: '', totalReceta: '', porPorcion: '', idr: '' });
    }
  };

  const handleDeleteIngredient = (ingredientId) => {
    setRecipe(prev => ({
      ...prev,
      ingredientes: prev.ingredientes.filter(ingredient => ingredient.id !== ingredientId)
    }));
  };

  const handleDeleteTiempoDia = (tiempoDiaId) => {
    setRecipe({
      ...recipe,
      tiemposDelDia: recipe.tiemposDelDia.filter(tiempoDia => tiempoDia.tiempoDiaId !== tiempoDiaId)
    });
  };

  const handleDeleteEtiqueta = (etiquetaId) => {
    setRecipe(prev => ({
      ...prev,
      etiquetasInformacionNutricional: prev.etiquetasInformacionNutricional
        .filter(e => (e.id ?? e.etiquetaId) !== etiquetaId)
    }));
  };

  const handleDeletePaso = (noPaso) => {
    setRecipe({
      ...recipe,
      procedimientos: recipe.procedimientos.filter(paso => paso.noPaso !== noPaso)
    });
  };

  const handleDeleteInfoNutricional = (id) => {
    setRecipe({
      ...recipe,
      informacionNutrimental: recipe.informacionNutrimental.filter(paso => paso.id !== id)
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result.split(',')[1];
      setRecipe({ ...recipe, imagen: base64String });
      setImagePreview(reader.result);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  return (
    <Box sx={{ padding: 3 }}>
      {loading ? (
        <CircularProgress sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
      ) : (
        <>
          <Typography variant="h4" gutterBottom>
            Editar Receta
          </Typography>

          <TextField
            label="Nombre"
            value={recipe.nombre}
            onChange={(e) => setRecipe({ ...recipe, nombre: e.target.value })}
            fullWidth
            margin="normal"
          />

          <TextField
            label="Descripción"
            value={recipe.descripcion}
            onChange={(e) => setRecipe({ ...recipe, descripcion: e.target.value })}
            fullWidth
            margin="normal"
            multiline
            rows={4}
          />

          <Grid2 container size={12} spacing={2}>
            <Grid2 size={{ sm: 12, md: 4 }}>
              <TextField
                label="Tiempo de Preparación (min)"
                type="number"
                value={recipe.tiempoPreparacion}
                onChange={(e) => setRecipe({ ...recipe, tiempoPreparacion: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid2>

            <Grid2 size={{ sm: 12, md: 4 }}>
              <TextField
                label="Tiempo de Cocción (min)"
                type="number"
                value={recipe.tiempoCoccion}
                onChange={(e) => setRecipe({ ...recipe, tiempoCoccion: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid2>

            <Grid2 size={{ sm: 12, md: 4 }}>
              <TextField
                label="Porciones"
                type="number"
                value={recipe.porciones}
                onChange={(e) => setRecipe({ ...recipe, porciones: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid2>
          </Grid2>

          <Grid2 container size={12} spacing={2}>
            <Grid2 size={{ sm: 12, md: 4 }}>
              <TextField
                select
                label="Estatus"
                value={recipe.estatus}
                onChange={(e) => setRecipe({ ...recipe, estatus: e.target.value })}
                fullWidth
                margin="normal"
              >
                <MenuItem value="Publicado">Publicado</MenuItem>
                <MenuItem value="Borrador">Borrador</MenuItem>
              </TextField>
            </Grid2>

            <Grid2 size={{ sm: 12, md: 4 }}>
              <TextField
                select
                label="Tipo de cocinero"
                value={recipe.tipoCocinero}
                onChange={(e) => setRecipe({ ...recipe, tipoCocinero: e.target.value })}
                fullWidth
                margin="normal"
              >
                <MenuItem value="Básico">Básico</MenuItem>
                <MenuItem value="Intermedio">Intermedio</MenuItem>
                <MenuItem value="Avanzado">Avanzado</MenuItem>
                <MenuItem value="Experto">Experto</MenuItem>
              </TextField>
            </Grid2>

            <Grid2 size={{ sm: 12, md: 4 }}>
              <TextField
                select
                label="Categoría Alimenticia"
                value={newCategoria.categoriaId}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  setNewCategoria({ ...newCategoria, categoriaId: selectedValue });
                  setRecipe({ ...recipe, categoria: selectedValue });
                }}
                fullWidth
                margin="normal"
              >
                {availableCategoria.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid2>
          </Grid2>

          <Divider sx={{ my: 2, backgroundColor: '#ccc' }} />

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                select
                label="Seleccionar Tiempos del día"
                value={newTiempoDia.tiempoDiaId}
                onChange={(e) => setNewTiempoDia({ ...newTiempoDia, tiempoDiaId: e.target.value })}
                fullWidth
                margin="normal"
              >
                {availableTiempoDia.map((tiempoDia) => (
                  <MenuItem key={tiempoDia.id} value={tiempoDia.id}>
                    {tiempoDia.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6} alignContent={'center'}>
              <Button class="button" variant="contained" color="primary" onClick={handleAddTiempoDia}>
                Añadir tiempo del dia
                <svg fill="currentColor" viewBox="0 0 24 24" class="icon">
                  <path
                    clip-rule="evenodd"
                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                    fill-rule="evenodd"
                  ></path>
                </svg>
              </Button>
            </Grid>

          </Grid>

          <List>
            {(recipe.tiemposDia ?? []).map((tiempoDia) => {
              console.log("Tiempos en receta:", recipe.tiemposDia);

              const tiempoDiaDetails = availableTiempoDia.find((i) => i.id === tiempoDia.id);

              return (

                <ListItem key={tiempoDia.id}>
                  <ListItemText
                    primary={tiempoDiaDetails?.nombre || 'Tiempo del día no disponible'}
                  />
                  <ListItemSecondaryAction>
                    <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteTiempoDia(tiempoDia.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List>
          <Divider sx={{ my: 2, backgroundColor: '#ccc' }} />
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                select
                label="Momento del día"
                value={newMomentoDia.momentoDiaId}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  const selectedMomento = availableMomentoDia.find(m => m.id === selectedValue);

                  setNewMomentoDia({ ...newMomentoDia, momentoDiaId: selectedValue });
                  setRecipe({ ...recipe, momentoDia: selectedMomento || null });
                }}
                fullWidth
                margin="normal"
              >
                {availableMomentoDia.map((momentoDia) => (
                  <MenuItem key={momentoDia.id} value={momentoDia.id}>
                    {momentoDia.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                select
                label="Clasificación de Receta"
                value={recipe.clasificacionReceta}
                onChange={e =>
                  setRecipe(prev => ({
                    ...prev,
                    clasificacionReceta: e.target.value
                  }))
                }
                fullWidth
                margin="normal"
              >
                {availableClasificacionReceta.map(c => (
                  <MenuItem key={c.id} value={c.id}>
                    {c.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>

          <Grid container spacing={2}>

            {/* GASTRONOMÍA */}
            <Grid item xs={6}>
              <TextField
                select
                label="Gastronomía"
                value={recipe.gastronomia}
                // onChange={(e) => setRecipe({ ...recipe, gastronomia: e.target.value })}
                onChange={e =>
                  setRecipe(prev => ({
                    ...prev,
                    gastronomia: e.target.value
                  }))
                }
                fullWidth
                margin="normal"
              >
                {availableGastronomias.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* FIT/FAT */}
            <Grid item xs={6}>
              <TextField
                select
                label="Fit o Fat"
                value={recipe.fitFat}
                onChange={(e) => setRecipe({ ...recipe, fitFat: e.target.value })}
                fullWidth
                margin="normal"
              >
                {availableFitFat.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* TEMPORADA */}
            <Grid item xs={6}>
              <TextField
                select
                label="Temporada"
                value={recipe.temporada}
                onChange={(e) => setRecipe({ ...recipe, temporada: e.target.value })}
                fullWidth
                margin="normal"
              >
                {availableTemporada.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* ALÉRGENO */}
            <Grid item xs={6}>
              <TextField
                select
                label="Alérgeno"
                value={recipe.alergeno}
                onChange={(e) => setRecipe({ ...recipe, alergeno: e.target.value })}
                fullWidth
                margin="normal"
              >
                {availableAlergeno.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

          </Grid>


          <TextField
            label="URL compra"
            value={recipe.urlCompra}
            onChange={(e) => setRecipe({ ...recipe, urlCompra: e.target.value })}
            fullWidth
            margin="normal"
          />

          <Typography variant="h6" gutterBottom>
            Ingredientes
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={5}>
              <TextField
                select
                label="Seleccionar Ingrediente"
                value={newIngredient.ingredienteId}
                onChange={(e) => setNewIngredient({ ...newIngredient, ingredienteId: e.target.value })}
                fullWidth
                margin="normal"
              >
                {availableIngredients.map((ingredient) => (
                  <MenuItem key={ingredient.id} value={ingredient.id}>
                    {ingredient.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={2}>
              <TextField
                label="Cantidad"
                value={newIngredient.cantidad}
                onChange={(e) => setNewIngredient({ ...newIngredient, cantidad: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Instrucciones"
                value={newIngredient.instrucciones}
                onChange={(e) => setNewIngredient({ ...newIngredient, instrucciones: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={2} alignContent={'center'}>
              <Button class="button" variant="contained" color="primary" onClick={handleAddIngredient}>
                Añadir Ingrediente
                <svg fill="currentColor" viewBox="0 0 24 24" class="icon">
                  <path
                    clip-rule="evenodd"
                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                    fill-rule="evenodd"
                  ></path>
                </svg>
              </Button>
            </Grid>
          </Grid>

          <List>
            {(recipe.ingredientes ?? []).map((ingredient) => {
              const ingredientDetails = availableIngredients.find((i) => i.id === ingredient.ingredienteId);
              return (
                <ListItem key={ingredient.id}>
                  <ListItemText
                    primary={ingredient?.nombre || 'Ingrediente no disponible'}
                    secondary={ingredient.cantidad}
                  />
                  <ListItemSecondaryAction>
                    <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteIngredient(ingredient.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List>

          <Divider sx={{ my: 2, backgroundColor: '#ccc' }} />

          <TextField
            label="NotaIdr"
            value={recipe.notaIdr}
            onChange={(e) => setRecipe({ ...recipe, notaIdr: e.target.value })}
            fullWidth
            margin="normal"
          />

          <Typography variant="h6" gutterBottom>
            Pasos
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                label="Descripcion"
                value={newPaso.descripcion}
                onChange={e => setNewPaso({
                  ...newPaso,
                  descripcion: e.target.value
                })}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={4} alignContent={'center'}>
              <FormControlLabel
                control={
                  <label class="container">
                    <input type="checkbox" checked={newPaso.esTip}
                      onChange={e => setNewPaso({
                        ...newPaso,
                        esTip: e.target.checked
                      })} />
                    <div class="checkmark"></div>
                  </label>
                }
                label="Es tip"
              />
            </Grid>
            <Grid item xs={2} alignContent={'center'}>
              <Button class="button" variant="contained" color="primary" onClick={handleAddPaso}>
                Añadir paso<svg fill="currentColor" viewBox="0 0 24 24" class="icon">
                  <path
                    clip-rule="evenodd"
                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                    fill-rule="evenodd"
                  ></path>
                </svg>
              </Button>
            </Grid>
          </Grid>

          <List>
            {((recipe.procedimientos ?? [])
              // 1) Hacemos una copia y la ordenamos por noPaso
              .slice()
              .sort((a, b) => a.noPaso - b.noPaso)
              // 2) Después mapeamos sobre el array ordenado
              .map(paso => (
                <ListItem key={paso.noPaso}>
                  <ListItemText
                    primary={`${paso.noPaso}.- ${paso.descripcion}`}
                    secondary={`es tip: ${paso.esTip}`}
                  />
                  <ListItemSecondaryAction>
                    <IconButton edge="end" aria-label="delete" onClick={() => handleDeletePaso(paso.noPaso)}>
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              ))
            )}
          </List>

          <Divider sx={{ my: 2, backgroundColor: '#ccc' }} />

          <Typography variant="h6" gutterBottom>
            Informacion Nutricional
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                label="Nutriente"
                value={newInfoNutricional.nutriente}
                onChange={(e) => setNewInfoNutricional({ ...newInfoNutricional, id: recipe.informacionNutrimental.length + 1, nutriente: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                label="Total Receta"
                value={newInfoNutricional.totalReceta}
                onChange={(e) => setNewInfoNutricional({ ...newInfoNutricional, id: recipe.informacionNutrimental.length + 1, totalReceta: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                label="Por Porcion"
                value={newInfoNutricional.porPorcion}
                onChange={(e) => setNewInfoNutricional({ ...newInfoNutricional, id: recipe.informacionNutrimental.length + 1, porPorcion: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                label="Idr"
                value={newInfoNutricional.idr}
                onChange={(e) => setNewInfoNutricional({ ...newInfoNutricional, id: recipe.informacionNutrimental.length + 1, idr: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={2} alignContent={'center'}>
              <Button class="button" variant="contained" color="primary" onClick={handleAddInfoNutricional}>
                Añadir<svg fill="currentColor" viewBox="0 0 24 24" class="icon">
                  <path
                    clip-rule="evenodd"
                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                    fill-rule="evenodd"
                  ></path>
                </svg>
              </Button>
            </Grid>
          </Grid>

          <List>
            {(recipe.informacionNutrimental ?? []).map((paso) => {
              return (
                <ListItem key={paso.id}>
                  <ListItemText
                    primary={paso.nutriente}
                    secondary={'' + paso.totalReceta + ' ' + paso.porPorcion + ' ' + paso.idr}
                  />
                  <ListItemSecondaryAction>
                    <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteInfoNutricional(paso.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List>

          <Divider sx={{ my: 2, backgroundColor: '#ccc' }} />

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                select
                label="Seleccionar Etiquetas de informacion nutricional"
                value={newEtiquetaInformacionNutricional.etiquetaId}
                onChange={(e) => setNewEtiquetaInformacionNutricional({ ...newEtiquetaInformacionNutricional, etiquetaId: e.target.value })}
                fullWidth
                margin="normal"
              >
                {availableEtiquetasInformacionNutricional.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6} alignContent={'center'}>
              <Button class="button" variant="contained" color="primary" onClick={handleAddEtiqueta}>
                Añadir etiqueta<svg fill="currentColor" viewBox="0 0 24 24" class="icon">
                  <path
                    clip-rule="evenodd"
                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                    fill-rule="evenodd"
                  ></path>
                </svg>
              </Button>
            </Grid>

          </Grid>

          {/* <List>
            {(recipe.etiquetaInformacionNutrimental ?? []).map((item) => {
              const foundedItem = availableEtiquetasInformacionNutricional.find((i) => i.id === item.etiquetaId);
              return (
                <ListItem key={item.tiempoDiaId}>
                  <ListItemText
                    primary={item?.nombre || 'Etiqueta no disponible'}
                  />
                  <ListItemSecondaryAction>
                    <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteEtiqueta(item.etiquetaId)}>
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List> */}

          <List>
            {(recipe.etiquetasInformacionNutricional ?? []).map((item) => {
              const etiquetaId = item.id ?? item.etiquetaId;
              const etiquetaDetails = availableEtiquetasInformacionNutricional.find(i => i.id === etiquetaId);

              return (
                <ListItem key={etiquetaId}>
                  <ListItemText
                    primary={etiquetaDetails?.nombre ?? item.nombre ?? 'Etiqueta no disponible'}
                  />
                  <ListItemSecondaryAction>
                    <IconButton
                      edge="end"
                      aria-label="delete"
                      onClick={() => handleDeleteEtiqueta(etiquetaId)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List>




          <Divider sx={{ my: 2, backgroundColor: '#ccc' }} />

          <Typography variant="h6" gutterBottom>
            Imagen de la Receta
          </Typography>
          <button class="upload-file-button">
            <svg
              aria-hidden="true"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-width="2"
                stroke="#fffffff"
                d="M13.5 3H12H8C6.34315 3 5 4.34315 5 6V18C5 19.6569 6.34315 21 8 21H11M13.5 3L19 8.625M13.5 3V7.625C13.5 8.17728 13.9477 8.625 14.5 8.625H19M19 8.625V11.8125"
                stroke-linejoin="round"
                stroke-linecap="round"
              ></path>
              <path
                stroke-linejoin="round"
                stroke-linecap="round"
                stroke-width="2"
                stroke="#fffffff"
                d="M17 15V18M17 21V18M17 18H14M17 18H20"
              ></path>
            </svg>
            Cargar Imagen
            <input type="file" accept="image/*" onChange={handleImageChange} />
          </button>
          {(recipe.urlImagen || imagePreview) && (
            <Box mt={2}>
              <img
                src={imagePreview || recipe.urlImagen}
                alt="Vista previa de la receta"
                style={{ width: '100%', maxHeight: '300px', objectFit: 'contain' }}
              />
            </Box>
          )}

          <Divider sx={{ my: 2, backgroundColor: '#ccc' }} />

          <Typography variant="h6" gutterBottom>
            Video de la Receta
          </Typography>
          <button class="upload-file-button">
            <svg
              aria-hidden="true"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-width="2"
                stroke="#fffffff"
                d="M13.5 3H12H8C6.34315 3 5 4.34315 5 6V18C5 19.6569 6.34315 21 8 21H11M13.5 3L19 8.625M13.5 3V7.625C13.5 8.17728 13.9477 8.625 14.5 8.625H19M19 8.625V11.8125"
                stroke-linejoin="round"
                stroke-linecap="round"
              ></path>
              <path
                stroke-linejoin="round"
                stroke-linecap="round"
                stroke-width="2"
                stroke="#fffffff"
                d="M17 15V18M17 21V18M17 18H14M17 18H20"
              ></path>
            </svg>
            Cargar Video
            <input
              type="file"
              accept="video/mp4,video/webm,video/ogg"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file && file.size > 100 * 1024 * 1024) { // Límite de 100MB
                  setUploadError('El video no puede superar 50MB');
                  return;
                }
                setVideoFile(file);
                setVideoPreview(URL.createObjectURL(file));
                setUploadError('');
              }}
              style={{ display: 'block', margin: '10px 0' }}
            />
          </button>

          {(videoPreview || videoUrl) && (
            <Box mt={2}>
              <video
                controls
                src={videoPreview}
                style={{ width: '100%', maxHeight: '300px', borderRadius: '8px' }}
              />
            </Box>
          )}

          {uploadError && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {uploadError}
            </Typography>
          )}
          <Grid container spacing={2} alignItems="center" sx={{ mt: 1, mb: 2 }}>
            <Grid item>

              <Button
                variant="contained"
                color="secondary"
                onClick={handleVideoUpload}
                disabled={!videoFile || uploadProgress > 0}
                sx={{ mt: 1, mb: 2 }}
              >
                {uploadProgress > 0 ? (
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <CircularProgress size={20} sx={{ mr: 1 }} />
                    Subiendo...
                  </Box>
                ) : (
                  'Subir Video'
                )}
              </Button>
            </Grid>
            {videoUrl && (
              <Grid item>
                <Button
                  variant="contained"
                  color="error"
                  onClick={async () => {
                    try {
                      // 1. Limpiar estados
                      setVideoUrl('');
                      setVideoFile(null);
                      setVideoPreview('');
                      setVideoUploaded(false);   // ocultar el alert de éxito

                      // 2. Mostrar alert de borrado
                      setVideoDeleted(true);

                      // 3. Auto-ocultar tras 2 minutos
                      setTimeout(() => setVideoDeleted(false), 2 * 60 * 1000);

                    } catch (error) {
                      setUploadError(error.message);
                    }
                  }}
                  sx={{ mt: 1, mb: 2 }}
                >
                  Eliminar Video
                </Button>
              </Grid>
            )}
          </Grid>
          {videoDeleted && (
            <Alert severity="error" sx={{ mt: 2 }}>
              Video eliminado exitosamente
            </Alert>
          )}
          {videoUploaded && (
            <Alert
              severity="success"
              sx={{ mt: 2 }}
              action={
                <IconButton
                  size="small"
                  onClick={() => navigator.clipboard.writeText(videoUrl)}
                >
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              }
            >
              Video subido exitosamente
            </Alert>
          )}

          <Divider sx={{ my: 2, backgroundColor: '#ccc' }} />

          <Typography variant="h6" gutterBottom>
            Metadatos SEO
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Meta Título"
                value={recipe.metaTitle || ''}
                onChange={(e) => setRecipe({ ...recipe, metaTitle: e.target.value })}
                fullWidth
                margin="normal"
                helperText="Máximo 70 caracteres"
                inputProps={{ maxLength: 70 }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Meta Descripción"
                value={recipe.metaDescription || ''}
                onChange={(e) => setRecipe({ ...recipe, metaDescription: e.target.value })}
                fullWidth
                margin="normal"
                multiline
                rows={3}
                helperText="Máximo 160 caracteres"
                inputProps={{ maxLength: 160 }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Palabras Clave"
                value={recipe.keyWords || ''}
                onChange={(e) => setRecipe({ ...recipe, keyWords: e.target.value })}
                fullWidth
                margin="normal"
                helperText="Separadas por comas"
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Texto Alternativo (Alt Text)"
                value={recipe.altText || ''}
                onChange={(e) => setRecipe({ ...recipe, altText: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Imagen Alternativa (URL)"
                value={recipe.altImage || ''}
                onChange={(e) => setRecipe({ ...recipe, altImage: e.target.value })}
                fullWidth
                margin="normal"
              />
            </Grid>
          </Grid>

          <Divider sx={{ my: 2, backgroundColor: '#ccc' }} />

          <Grid container spacing={2}>
            <Grid item xs={12}>

              <Button
                variant="contained"
                color="primary"
                onClick={handleSave}
                sx={{ mt: 2 }}
              >
                Guardar Cambios
              </Button>
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
};

export default EditRecipe;
